module.exports = __webpack_public_path__ + "static/germany-dc04e5144d4b94aae0204789751b3c71.jpeg";